import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  apiUrl = environment.API_URL;

  constructor(
    private http: HttpClient
  ) { }

  post(url: string, reqData: IHttpData): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post<IApiResponse>(`${this.apiUrl}${url}`, reqData).subscribe({
        next: data => resolve(data),
        error: err => reject(err),
      });
    });
  }

  put(url:string, data?: IHttpData){
    return new Promise((resolve, reject) => {
      this.http.put<IApiResponse>(`${this.apiUrl}${url}`, data).subscribe({
        next: data => resolve(data),
        error: err => reject(err),
      });
    });
  }

  get(url: string, options?: HttpParams) {
    return new Promise((resolve, reject) => {
      this.http.get<IApiResponse>(`${this.apiUrl}${url}`, { params: options }).subscribe({
        next: data => resolve(data),
        error: err => reject(err),
      });
    });
  }

  delete(url: string, body?: IHttpData) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: body
    }
    return new Promise((resolve, reject) => {
      this.http.delete<IApiResponse>(`${this.apiUrl}${url}`, options).subscribe({
        next: data => resolve(data),
        error: err => reject(err),
      });
    });
  }

  getByUrl(url: string, options: HttpParams) {
    return new Promise((resolve, reject) => {
      this.http.get<IApiResponse>(`${url}`, { params: options }).subscribe({
        next: data => resolve(data),
        error: err => reject(err),
      });
    });
  }
}

export interface IHttpData {
  [key: string]: any;
}

export interface IApiResponse {
  [key: string]: any;
  data: any;
  error: any;
  message: string;
  statusCode: 200;
}
